import { StatWidget } from '@/components/widgets/StatWidget';
import { formatNumber } from '@/utils/format';
import type { SectionView } from './helpers';

interface ReconSectionProps {
  view: SectionView;
  assetsLabel: string;
  liabilitiesValue: number;
  // Navigation targets (null = not clickable).
  onAssetsClick?: (() => void) | null;
  onLiabilitiesClick?: (() => void) | null;
}

// A RenderSection: Assets + Liabilities side by side, then a centered Result card.
export function ReconSection({ view, assetsLabel, liabilitiesValue, onAssetsClick, onLiabilitiesClick }: ReconSectionProps) {
  const positive = view.result >= 0;
  const hoverClass = positive ? 'hover-clickable-primary-animation' : 'hover-clickable-danger-animation';
  const resultGlow = positive ? 'recon-result-excess' : 'recon-result-shortfall';
  const resultColor = positive ? 'text-primary' : 'text-danger';
  const tooltip = `${view.message} ${formatNumber(Math.abs(view.result), 2)}`;

  return (
    <div className="recon-widget">
      <div className="row g-3">
        <div className="col-md-6">
          <StatWidget
            label={assetsLabel}
            value={formatNumber(view.assetsValue, 2)}
            icon="fa-solid fa-building-columns"
            theme="primary"
            cardClassName={onAssetsClick ? hoverClass : undefined}
            onClick={onAssetsClick ?? undefined}
          />
        </div>
        <div className="col-md-6">
          <StatWidget
            label="Clients' Liabilities"
            value={formatNumber(liabilitiesValue, 2)}
            icon="fa-solid fa-users"
            theme="info"
            cardClassName={onLiabilitiesClick ? hoverClass : undefined}
            onClick={onLiabilitiesClick ?? undefined}
          />
        </div>
      </div>
      <div className="row g-3 justify-content-center mt-1">
        <div className="col-md-6">
          <StatWidget
            label={view.title}
            value={formatNumber(view.result, 2)}
            icon={positive ? 'fa-solid fa-arrow-trend-up' : 'fa-solid fa-arrow-trend-down'}
            theme={positive ? 'primary' : 'danger'}
            valueClassName={`recon-widget-value ${resultColor}`}
            cardClassName={resultGlow}
            tooltip={tooltip}
          />
        </div>
      </div>
    </div>
  );
}
